"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["variant", "label", "emphasis"];

var Label = function Label(props) {
  var variant = props.variant,
      label = props.label,
      _props$emphasis = props.emphasis,
      emphasis = _props$emphasis === void 0 ? 'high' : _props$emphasis,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var labelClasses = (0, _classnames.default)('label-component', // Probably we have `label` class in global CSS, so using `label-component` to avoid conflicts
  "label--".concat(variant), "label--emphasis-".concat(emphasis));
  return (0, _preact.h)("span", (0, _extends2.default)({
    className: labelClasses
  }, restProps), label);
};

var _default = Label;
exports.default = _default;